import { render, staticRenderFns } from "./TableCheckRequireColumnPanel.vue?vue&type=template&id=06f68181&scoped=true"
import script from "./TableCheckRequireColumnPanel.vue?vue&type=script&lang=js"
export * from "./TableCheckRequireColumnPanel.vue?vue&type=script&lang=js"
import style0 from "./TableCheckRequireColumnPanel.vue?vue&type=style&index=0&id=06f68181&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f68181",
  null
  
)

export default component.exports